(ns ballot-scout-v2-frontend.resources.views
  (:require
   ["qrcode.react" :as qrcode]
   [ballot-scout-v2-frontend.components.icon :refer [icon] :as icon]
   [ballot-scout-v2-frontend.config :as config]
   [ballot-scout-v2-frontend.request-helpers :as request-helpers]
   [ballot-scout-v2-frontend.resources.events :as e.resources]
   [ballot-scout-v2-frontend.resources.subs :as s.resources]
   [ballot-scout-v2-frontend.subs :as subs]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(defn using-the-ballot-scout-portal [{:keys [general-user-guide
                                             partner-admin-user-guide
                                             import-guide
                                             disposition-guide
                                             sample-mail-file
                                             sample-dispo-file]}
                                     {:keys [partner?]}]
  [:section {:class "" :id "using-the-ballot-scout-portal"}
   [:hr]
   [:div {:class "content"}
    [:h2 {:class "heading-2"} "Using the Ballot Scout Portal"]
    [:div {:class "columns is-desktop"}
     [:div {:class "column is-two-fifths-desktop"}
      [:h4 {:class "heading-4 has-text-weight-medium" :id "user-guides"}
       "User Guides"]
      [:div "Using Ballot Scout and answering voter questions"
       [:ul
        (when (and (not partner?) general-user-guide)
          [:li [:a {:href general-user-guide :target "_blank"}
                "View General User Guide (PDF)"]])
        (when (and (or @(rf/subscribe [::subs/can-view-partner-admin-pages?]) partner?)
                   partner-admin-user-guide)
          [:li [:a {:href partner-admin-user-guide :target "_blank"}
                "View Admin User Guide (PDF)"]])
        (when import-guide
          [:li [:a {:href import-guide :target "_blank"}
                "View Voter Import Guide (PDF)"]])
        (when disposition-guide
          [:li [:a {:href disposition-guide :target "_blank"}
                "View Disposition Import Guide (PDF)"]])
        [:li [:a {:href config/default-faq-url :target "_blank"}
              "Visit Ballot Scout Voter FAQ"]]]]]
     [:div {:class "column is-three-fifths-desktop"}
      [:h4 {:class "heading-4 has-text-weight-medium" :id "sample-files"}
       "Sample Files"]
      [:div "Learning how to format files for Ballot Scout"
       [:ul
        (when sample-mail-file
          [:li [:a {:href sample-mail-file :target "_blank"}
                "View Sample Voter Import File (PDF)"]])
        (when sample-dispo-file
          [:li [:a {:href sample-dispo-file :target "_blank"}
                "View Sample Disposition File (PDF)"]])]]]]]])

(defn qr-code-view [{:keys [value]}]
  (r/with-let [qr-code-el (r/atom nil)]
    [:div {:class "column is-three-fifths-desktop"}
     [:h2 {:class "heading-2"} "Using a QR Code to Share the Ballot Tracking Tool"]
     "QR codes (Quick-Response codes) are easily readable barcodes that when scanned translate the code into a URL or other data."
     [:strong " You can download, share, and even print this QR code and when scanned it will link directly to your unique Ballot Tracking Tool!"]
     [:div {:class "qr-container pt-4 pb-4"
            :ref (fn [el]
                   (when-not @qr-code-el
                     (reset! qr-code-el el)))}
      [:> qrcode {:value value
                  :size 280
                  :renderAs "canvas"
                  :level "M"}]]
     (let [href (when @qr-code-el
                  (-> (.getElementsByTagName @qr-code-el "canvas")
                      first
                      (.toDataURL "image/png")))]
       [:div {:class "mt-5"}
        [:a {:download (str "BallotScout_QR_Code.png")
             :href href}
         [:button {:class "button is-primary"}
          [icon ::icon/download {:class "mr-2"}] "Download QR Code"]]])]))

(defn promoting-ballot-scout [{:keys [insert-templates
                                      logos-and-graphics
                                      social-media-graphics
                                      voter-infographics
                                      sample-press-release
                                      sample-social-media]}
                              {:keys [partner?]}]
  (let [partner @(rf/subscribe [::subs/current-partner])
        jurisdiction @(rf/subscribe [::subs/current-jurisdiction])
        origin (.. js/window -location -origin)
        track-url (if partner?
                    (str origin "/" (:partner/slug partner) "/track/state")
                    (str origin "/" (:jurisdiction/slug jurisdiction) "/track"))]
    [:section {:id "promoting-ballot-scout"}
     [:hr]
     [:div {:class "content"}
      [:div {:class "columns is-desktop"}
       [:div {:class "column is-two-fifths-desktop"}
        [:h2 {:class "heading-2"} "Promoting Ballot Scout"]
        [:h4 {:class "heading-4 has-text-weight-medium"} "Marketing Materials"]
        [:p "Promoting Ballot Scout with graphics and communications"]
        [:ul
         (when insert-templates
           [:li [:a {:href insert-templates :target "_blank"}
                 "Download Ballot Inserts (.pdf)"]])
         (when sample-press-release
           [:li [:a {:href sample-press-release :target "_blank"}
                 "Download Sample Press Release (.docx)"]])
         (when sample-social-media
           [:li [:a {:href sample-social-media :target "_blank"}
                 "Download Sample Social Posts (.docx)"]])
         (when social-media-graphics
           [:li [:a {:href social-media-graphics :target "_blank"}
                 "Download Ballot Scout Social Media Graphics (.png)"]])
         (when voter-infographics
           [:li [:a {:href voter-infographics :target "_blank"}
                 "Download Ballot Scout Voter Infographics (.png)"]])
         (when logos-and-graphics
           [:li [:a {:href logos-and-graphics :target "_blank"}
                 "Download Ballot Scout Logos (multiple files)"]])]]
       [qr-code-view {:value track-url}]]]]))

(defn embedding-the-ballot-scout-widget [{:keys [ballot-tracking-tool-updates-09-2022]} {:keys [partner?]}]
  (let [partner @(rf/subscribe [::subs/current-partner])
        jurisdiction @(rf/subscribe [::subs/current-jurisdiction])
        origin (.. js/window -location -origin)
        embed-url (if partner?
                    (str origin "/" (:partner/slug partner) "/search/state")
                    (str origin "/" (:jurisdiction/slug jurisdiction) "/search"))
        track-url (if partner?
                    (str origin "/" (:partner/slug partner) "/track/state")
                    (str origin "/" (:jurisdiction/slug jurisdiction) "/track"))
        allow-widget (if partner?
                       (:partner/allow-widget partner)
                       (and (:jurisdiction/allow-widget jurisdiction) (:partner/allow-widget partner)))]
    (when allow-widget
      [:section {:id "embedding-the-ballot-scout-widget"}
       [:hr {:class "my-6"}]
       [:div {:class "content"}
        [:div {:class "columns is-desktop"}
         [:div {:class "column is-two-fifths-desktop pr-6"}
          [:iframe {:src embed-url
                    :align "middle"
                    :style {:width "100%"
                            :height "900px"
                            :margin-top "0"}
                    :scrolling "no"
                    :marginWidth "0"
                    :marginHeight "0"
                    :frameBorder "0"
                    :vspace "0"
                    :title "Ballot Scout Widget"}]]
         [:hspace]
         [:div {:class "column is-three-fifths-desktop"}
          [:h2 {:class "heading-2"} "The Ballot Tracking Tool"]
          [:div
           [:p "This tool allows voters to track their ballot and sign up for notifications."]
           [:p {:class "has-text-weight-bold"}
            "We recently launched some updates to the tool!"
            [:a {:class "mx-1"
                 :href ballot-tracking-tool-updates-09-2022 :target "_blank"}
             "Learn more (PDF)"]]]

          [:div {:class "mt-4"}
           [:p "To embed the tool on your website, use the following iframe code"]
           [:pre {:class "line-wrap is-size-7"}
            (str "<iframe src=\"" embed-url "\" align=\"middle\" style=\"width: 100%; height: 1000px\" scrolling=\"no\" marginwidth=\"0\" marginheight=\"0\" frameborder=\"0\" vspace=\"0\" hspace=\"0\"> </iframe>")]
           [:p "If you do not wish to embed the tool, you may link to where we host it: "
            [:div [:a {:href track-url :target "_blank"}
                   track-url]]]]

          [:div {:class "mt-4"}
           [:p
            "Below are the statuses that a voter can expect to see upon searching with their name and address:"]
           [:ul
            [:li [:strong "Being Prepared "] [:small "(status created by the voter import)"]]
            [:li [:strong "Mailed to You "] [:small "(status created by USPS scan or disposition data)"]]
            [:li [:strong "Delivery Scheduled "] [:small "(status created by USPS scan data)"]]
            [:li [:strong "Returned to Sender "] [:small "(status created by USPS scan data)"]]
            [:li [:strong "Mailed to Office "] [:small "(status created by USPS scan data)"]]
            [:li [:strong "Received by Office "] [:small "(status created by USPS scan or disposition data)"]]
            [:li [:strong "Received by Office - Accepted "] [:small "(status created only by disposition data)"]]
            [:li [:strong "Received by Office - Flagged "] [:small "(status created only by disposition data)"]]]]

          [:p {:class "mt-4"}
           "More detailed information about these statuses is available on the "
           [:a {:href config/default-faq-url :target "_blank"} "FAQ page"]
           ", which is also available from the "
           [:span {:class "has-text-underlined"} [icon ::icon/question-circle {:type ::icon/solid}] "Learn More"]
           " link at the bottom of the Tracking Tool."]]]]])))

(defn page []
  (let [resource-urls @(rf/subscribe [::s.resources/resource-urls])
        fetch-error @(rf/subscribe [::request-helpers/failed-request
                                    [::e.resources/fetch-resource-urls]])]
    (cond
      (some? resource-urls)
      [:div {:class "resources"}
       [:h1 {:class "heading-1"} "Guides and Resources"]
       [using-the-ballot-scout-portal resource-urls]
       [promoting-ballot-scout resource-urls]
       [embedding-the-ballot-scout-widget resource-urls]]

      fetch-error
      (:status-text fetch-error)

      :else
      [:div {:class "level"}
       [:div {:class "level-item"}
        [:div.loading
         [:img {:class "p-2" :src "/images/compass-100x100.png"}]]]])))

(defn partner-page []
  (let [resource-urls @(rf/subscribe [::s.resources/resource-urls])
        fetch-error @(rf/subscribe [::request-helpers/failed-request
                                    [::e.resources/fetch-resource-urls]])]
    (cond
      (some? resource-urls)
      [:div {:class "resources"}
       [:h1 {:class "heading-1"} "Guides and Resources"]
       [using-the-ballot-scout-portal resource-urls {:partner? true}]
       [promoting-ballot-scout resource-urls {:partner? true}]
       [embedding-the-ballot-scout-widget resource-urls {:partner? true}]]

      fetch-error
      (:status-text fetch-error)

      :else
      [:div {:class "level"}
       [:div {:class "level-item"}
        [:div.loading
         [:img {:style {:padding "2em"} :src "/images/compass-100x100.png"}]]]])))
